import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolBarActionsComponent } from './tool-bar-actions.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { PerfilUsuarioModule } from '../perfil-usuario/perfil-usuario.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ShowIfAuthorizedModule } from 'src/app/directives/show-if-authorized/show-if-authorized.module';
import { NotificacoesComponent } from '../notificacoes/notificacoes.component';

import { CdkMenuModule } from '@angular/cdk/menu';


@NgModule({
  declarations: [ToolBarActionsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatBadgeModule,
    FormsModule,
    PerfilUsuarioModule,
    MatCheckboxModule,
    MatTooltipModule,
    ShowIfAuthorizedModule,
    CdkMenuModule,
    NotificacoesComponent
  ],
  exports: [ToolBarActionsComponent]
})
export class ToolBarActionsModule { }
